// Геометрия рабочей стороны обложки из этапа 3, миллиметры.
export const normalizeCoverShape = (value) =>
  ["square", "rectangle"].includes(value) ? value : "legacy";

export function coverPhotoGeometry(bookSize, shape) {
  const a4 = Number(bookSize?.heightMm || 0) >= 230;
  const sideW = a4 ? 175 : 140, sideH = a4 ? 250 : 210;
  const kind = normalizeCoverShape(shape);
  if (kind === "legacy") return null;
  const [w, h, top] = a4
    ? (kind === "square" ? [125, 125, 72.77] : [110, 146.67, 61.93])
    : (kind === "square" ? [100, 100, 65] : [84, 112, 59]);
  return { sideW, sideH, w, h, top, aspect: w / h,
    sx: { position: "absolute", top: `${top / sideH * 100}%`,
      left: `${(sideW - w) / 2 / sideW * 100}%`, right: "auto",
      width: `${w / sideW * 100}%`, height: `${h / sideH * 100}%`, transform: "none" },
    logoSx: { position: "absolute", left: "50%", transform: "translateX(-50%)",
      bottom: `${(a4 ? 10.92 : 15) / sideH * 100}%`,
      width: `${(a4 ? 25 : 23) / sideW * 100}%`,
      height: a4 ? `${9.5 / sideH * 100}%` : "auto",
      objectFit: "contain", objectPosition: "center bottom", display: "block", pointerEvents: "none" },
  };
}

// Заголовок/дата/стикер/сетка: те же миллиметры, что get_cover_content_layout.
export function coverContentLayout(bookSize, kind) {
  if (kind === "legacy") return null;
  const base = coverPhotoGeometry(bookSize, "square");
  const a4 = base.sideH === 250;
  const titleH = a4 ? 30 : 26.5;
  const yearGap = a4 ? { square: 8.47, rectangle: 8.47, sticker: 8.47, grid: 8.47 }[kind] : 7.17;
  if (yearGap === undefined) throw new Error(`Неизвестная разметка: ${kind}`);
  const cellW = a4 ? 54 : 45, cellH = a4 ? 72 : 60, gap = a4 ? 3 : 2;
  const gridW = 2 * cellW + gap, gridH = 2 * cellH + gap;
  const gridTop = a4 ? 61.93 : 54;
  // У стикера отдельная координата: изменение сетки не сдвигает стикер.
  const stickerTop = a4 ? 61.93 : 54, stickerH = a4 ? 156 : gridH;
  return { ...base, safe: 8, titleH, titleMaxCap: a4 ? 19 : 15,
    yearGap, yearH: a4 ? 7 : 5.4, yearW: a4 ? 31.08 : 24,
    yearMaxW: a4 ? 120 : 100, cellAspect: cellW / cellH,
    gridSx: { top: `${gridTop / base.sideH * 100}%`,
      width: `${gridW / base.sideW * 100}%`, height: `${gridH / base.sideH * 100}%`,
      columnGap: `${gap / gridW * 100}%`, rowGap: `${gap / gridH * 100}%` },
    stickerSx: { top: `${stickerTop / base.sideH * 100}%`,
      left: `${8 / base.sideW * 100}%`, right: `${8 / base.sideW * 100}%`,
      height: `${stickerH / base.sideH * 100}%`, transform: "none", borderRadius: 0 },
  };
}